import {Box} from 'components/Grid';
import {Typography} from 'components/Typography';
import {EventXTastingProductsSlider} from 'modules/events/components/EventXTastingProductsSlider';
import {FC} from 'react';
import style from './style.module.scss';
import {EventXTastingProductsInfo} from 'modules/events/components/EventXTastingProductsInfo';
import {IProductShortResponse} from 'modules/products/models';
import {useRouter} from 'next/router';
import {useGetEventQuery} from 'modules/events/services';

interface IEventXTastingProductsProps {
    tastingProductsData?: IProductShortResponse;
}

export const EventXTastingProducts: FC<IEventXTastingProductsProps> = ({tastingProductsData}) => {
    const {query} = useRouter();
    const {data} = useGetEventQuery({id: query.slug as string});
    const event = data?.data;
    const {items} = tastingProductsData || {};
    const description = event?.detailedDescription ?? '';

    return (
        <div>
            <Box>
                <Typography element={'div'} variant={'price-20-b'}>
                    Что будем пробовать
                </Typography>
                {description && (
                    <Typography className={style.description} element={'div'} variant={'body-16-r'}>
                        {description}
                    </Typography>
                )}
                {Boolean(items?.length) ? (
                    <>
                        <div className={style.products}>
                            <EventXTastingProductsSlider tastingProductsData={tastingProductsData} />
                        </div>
                        <div className={style.info}>
                            <EventXTastingProductsInfo />
                        </div>
                    </>
                ) : null}
            </Box>
        </div>
    );
};
